export function getCookieValue(name: string): string | null {
  const value = document.cookie
    .split('; ')
    .find(row => row.startsWith(`${name}=`));

  return value ? decodeURIComponent(value.split('=')[1]) : null;
}

export function isTokenExpired(token: string): boolean {
  try {
    const payload = token.split('.')[1];
    if (!payload) {
      return true;
    }

    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const decoded = JSON.parse(atob(base64)) as { exp?: number };

    if (!decoded.exp) {
      return false;
    }

    return decoded.exp * 1000 < Date.now();
  } catch {
    return true;
  }
}

export function isTokenValid(token: string | null): boolean {
  return !!token && !isTokenExpired(token);
}
